import React from 'react'
import PropTypes from 'prop-types'

const WorkItems = ({ item }) => {
  const hasLink = Boolean(item.link) && item.link.startsWith("https://");

  return (
    <article className="work__card">
        <div className={`work__img-wrap work__img-wrap--${item.fit || 'cover'}`}>
            <img
              src={item.image}
              alt={`${item.title} logo`}
              className='work__img'
              loading="lazy"
            />
            {item.rating && (
              <span className="work__rating" aria-label={`Rated ${item.rating} out of 5 from ${item.reviews} reviews`}>
                <i className="bx bxs-star work__rating-icon" aria-hidden="true"></i>
                {item.rating} <span className="work__rating-count">({item.reviews})</span>
              </span>
            )}
        </div>

        <h3 className="work__title">{item.title}</h3>

        {item.description && (
          <p className="work__description">{item.description}</p>
        )}

        {item.tags?.length > 0 && (
          <ul className="work__tags">
            {item.tags.map((tag) => (
              <li className="work__tag" key={tag}>{tag}</li>
            ))}
          </ul>
        )}

        {hasLink ? (
          <a href={item.link} target="_blank" rel="noopener noreferrer" className="work__button">
              {item.linkLabel || 'View project'}
              <i className="bx bx-right-arrow-alt work__button-icon" aria-hidden="true"></i>
          </a>
        ) : (
          <span className="work__button work__button--disabled">Private project</span>
        )}
    </article>
  )
}

WorkItems.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    fit: PropTypes.oneOf(['cover', 'contain']),
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    category: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string),
    rating: PropTypes.number,
    reviews: PropTypes.number,
    link: PropTypes.string,
    linkLabel: PropTypes.string,
  }).isRequired,
};

export default WorkItems
